import { REHYDRATE_USER_SESSION, SET_UP_USER_PRODUCT, UPDATE_USER_PRODUCT_PRICE_REQUEST, UPDATE_USER_PRODUCT_REQUEST, SET_UP_USER_HOTEL } from "../types";

export const rehydrateUserSession = session => ({ type: REHYDRATE_USER_SESSION, payload: JSON.parse(session) });

export const setUpHotel = ({ hotel }) => ({ type: SET_UP_USER_HOTEL, payload: { hotel } });

export const setUpProduct = ({ product }) => ({ type: SET_UP_USER_PRODUCT, payload: { product } });

export const updateProduct = name => ({ type: UPDATE_USER_PRODUCT_REQUEST, payload: name });

export const updateProductPrice = day => ({ type: UPDATE_USER_PRODUCT_PRICE_REQUEST, payload: day });
